import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/user-circle': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 104C195 104 152 147 152 200S195 296 248 296 344 253 344 200 301 104 248 104zM248 248C221.5 248 200 226.5 200 200S221.5 152 248 152 296 173.5 296 200 274.5 248 248 248zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C198.3 456 152.9 437.7 117.9 407.6 132.8 384.6 158.3 369 187.5 368.1 208.3 374.5 228.1 377.7 248 377.7S287.7 374.6 308.5 368.1C337.7 369.1 363.2 384.6 378.1 407.6 343.1 437.7 297.7 456 248 456zM410.7 371.9C386.3 340.5 348.6 320 305.6 320 295.4 320 279.6 329.6 248 329.6 216.5 329.6 200.6 320 190.4 320 147.5 320 109.8 340.5 85.3 371.9 61.9 339.2 48 299.2 48 256 48 145.7 137.7 56 248 56S448 145.7 448 256C448 299.2 434.1 339.2 410.7 371.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/user-circle.js
// module id = kQgd
// module chunks = 144